import { render } from "./CourseSnap.vue?vue&type=template&id=30a09ade&scoped=true"
import script from "./CourseSnap.vue?vue&type=script&lang=js"
export * from "./CourseSnap.vue?vue&type=script&lang=js"

import "./CourseSnap.vue?vue&type=style&index=0&id=30a09ade&lang=scss&scoped=true"
import "./CourseSnap.vue?vue&type=style&index=1&id=30a09ade&lang=scss&scoped=true"

import exportComponent from "/root/workspace/yatinjuryplatformwebcode_Vf1x/CODE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a09ade"]])

export default __exports__